module.exports = __webpack_public_path__ + "img/icon_header_user.c9755fcd.svg";